import { Typography } from '@mui/material'

// Types
import type { TypographyProps } from '@/types/components/atoms/typography'

// Small pill label shown above section titles
const EyebrowTypographyAtom = (props: TypographyProps) => {
	// Props
	const { text } = props

	return (
		<Typography
			component="span"
			sx={{
				display: 'inline-block',
				px: 1.5,
				py: 0.5,
				borderRadius: 10,
				fontSize: 13,
				fontWeight: 500,
				color: 'primary.dark',
				bgcolor: 'primary.ultralight'
			}}
		>
			{text}
		</Typography>
	)
}

export default EyebrowTypographyAtom
